<template>
  <section>
    <carousel
      ref="carousel"
      :navigation-enabled="false"
      :pagination-enabled="true"
      :per-page="1"
      :scroll-per-page="true"
      :autoplay="true"
      :autoplay-timeout="4000"
      :autoplay-hover-pause="false"
      :loop="true"
      :pagination-active-color="bannerPaginationColorActive"
      :pagination-color="bannerPaginationColor"
      :pagination-size="12"
      :touch-drag="false"
      :mouse-drag="false"
      @pagination-click="paginationClick"
    >
      <slide
        v-for="(banner, index) in banners"
        :id="`insp-${index}`"
        :key="index"
        :title="banner.title"
      >
        <inspirational-banner-item :banner="banner" />
      </slide>
    </carousel>
  </section>
</template>

<script>
  import { mapState } from 'vuex'
  import { Carousel, Slide } from 'vue-carousel'

  export default {
    components: {
      Carousel,
      Slide,
      'inspirational-banner-item': () =>
        import(
          /* webpackChunkName: "inspirational-banner-item" */ 'containers/Pages/IndexPage/InspirationalBannerItem'
        )
    },
    props: {
      banners: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        bannerPaginationColor: 'rgba(21,38,73,0.2)',
        bannerPaginationColorActive: '#152649'
      }
    },
    computed: {
      ...mapState('device', ['deviceType'])
    },
    methods: {
      paginationClick() {
        this.$refs.carousel.restartAutoplay()
      }
    }
  }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
  @import '~assets/styles/common.scss';
  @import '~assets/styles/keyframes.scss';

  $animationTime: 4s;

  ::v-deep .VueCarousel-dot {
    position: relative;
    padding: 0 !important;
    overflow: visible;
    margin-right: 15px;

    &:before {
      content: '';
    }
  }

  ::v-deep .VueCarousel-dot--active {
    &:before {
      position: absolute;
      left: -3px;
      top: -3px;
      display: block;
      height: 18px;
      width: 18px;
      border: 1px solid;
      border-radius: 50%;
      animation: spin $animationTime infinite linear;
      border-color: $blue-dark transparent transparent transparent;
    }
  }
</style>
